"use strict";

var _slicedToArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorsElement = void 0;

var Point2D_1 = require("../../Core/Point2D");

var IRegionCallbacks_1 = require("../../Interface/IRegionCallbacks");

var AnchorsComponent_1 = require("../Component/AnchorsComponent");
/**
 * `AnchorsComponent` for the `RectRegion` class.
 * @todo Current implementations of bones reuses existing aprroach with anchor index
 * by using negative indexes and manually correcting them to actual indexes.
 * It seems like it should be refactored some how.
 */


var AnchorsElement = /*#__PURE__*/function (_AnchorsComponent_1$A) {
  _inherits(AnchorsElement, _AnchorsComponent_1$A);

  /**
   * Creates a new `AnchorsElement` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function AnchorsElement(paper) {
    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, AnchorsElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnchorsElement).call(this, paper, paperRect, regionData, callbacks));
  }
  /**
   * Redraws the visual on the component.
   */


  _createClass(AnchorsElement, [{
    key: "redraw",
    value: function redraw() {
      var _this = this;

      _get(_getPrototypeOf(AnchorsElement.prototype), "redraw", this).call(this);

      var _ref = [this.regionData.x, this.regionData.y, this.regionData.width, this.regionData.height],
          x = _ref[0],
          y = _ref[1],
          width = _ref[2],
          height = _ref[3];

      var _this$anchorBones = _slicedToArray(this.anchorBones, 4),
          tBone = _this$anchorBones[0],
          rBone = _this$anchorBones[1],
          bBone = _this$anchorBones[2],
          lBone = _this$anchorBones[3];

      window.requestAnimationFrame(function () {
        tBone.attr({
          x: x,
          y: y - _this.boneThickness / 2,
          width: width,
          height: _this.boneThickness
        });
        rBone.attr({
          x: x + width - _this.boneThickness / 2,
          y: y,
          width: _this.boneThickness,
          height: height
        });
        bBone.attr({
          x: x,
          y: y + height - _this.boneThickness / 2,
          width: width,
          height: _this.boneThickness
        });
        lBone.attr({
          x: x - _this.boneThickness / 2,
          y: y,
          width: _this.boneThickness,
          height: height
        });
      });
    }
    /**
     * Creates a collection on anchors.
     */

  }, {
    key: "buildAnchors",
    value: function buildAnchors() {
      this.buildBoneAnchors();

      _get(_getPrototypeOf(AnchorsElement.prototype), "buildAnchors", this).call(this);
    }
    /**
     * Creates collection of anchor points.
     */

  }, {
    key: "buildPointAnchors",
    value: function buildPointAnchors() {
      var _this2 = this;

      this.anchorPointStyles = ["TL", "TR", "BR", "BL"];
      this.regionData.points.forEach(function (point, index) {
        var anchor = _this2.createAnchor(_this2.paper, point.x, point.y, _this2.anchorPointStyles[index]);

        _this2.anchors.push(anchor);

        _this2.anchorsNode.add(anchor);

        _this2.subscribeAnchorToEvents(anchor, index + 1);
      });
    }
    /**
     * Creates collection of anchor bones.
     */

  }, {
    key: "buildBoneAnchors",
    value: function buildBoneAnchors() {
      var _this$anchorBones2,
          _this3 = this;

      this.anchorBoneStyles = ["T", "R", "B", "L"];
      this.anchorBones = [];
      this.boneThickness = AnchorsComponent_1.AnchorsComponent.DEFAULT_GHOST_ANCHOR_RADIUS;
      var _ref2 = [this.regionData.x, this.regionData.y, this.regionData.width, this.regionData.height],
          x = _ref2[0],
          y = _ref2[1],
          w = _ref2[2],
          h = _ref2[3];
      var tBone = this.createAnchorBone(this.paper, x, y, w, 0, "T", this.boneThickness);
      var rBone = this.createAnchorBone(this.paper, x + w, y, 0, h, "R", this.boneThickness);
      var bBone = this.createAnchorBone(this.paper, x, y + h, w, 0, "B", this.boneThickness);
      var lBone = this.createAnchorBone(this.paper, x, y, 0, h, "L", this.boneThickness);
      var bones = [tBone, rBone, bBone, lBone];

      (_this$anchorBones2 = this.anchorBones).push.apply(_this$anchorBones2, bones);

      bones.forEach(function (bone, index) {
        _this3.anchorsNode.add(bone); // Using already existing infrastructure for indexes


        _this3.subscribeAnchorBoneToEvents(bone, -(index + 1));
      });
    }
    /**
     * Helper function to create a new anchor bone.
     * @param paper - The `Snap.Paper` object to draw on.
     * @param x - The `x`-coordinate of the acnhor bone.
     * @param y - The `y`-coordinate of the anchor bone.
     * @param width - The `width` of the anchor bone.
     * @param height - The `height` of the anchor bone.
     * @param style - Additional css style class to be applied.
     * @param thickness - The `thickness` of the bone (activation area).
     */

  }, {
    key: "createAnchorBone",
    value: function createAnchorBone(paper, x, y, width, height, style) {
      var thickness = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : AnchorsComponent_1.AnchorsComponent.DEFAULT_GHOST_ANCHOR_RADIUS;
      var bone;

      if (width === 0) {
        bone = paper.rect(x - thickness / 2, y, thickness, height);
      } else if (height === 0) {
        bone = paper.rect(x, y - thickness / 2, width, thickness);
      } else {
        throw Error("Rect bones that are neither vertical or horizontal are not supported.");
        return null;
      }

      bone.addClass("anchorBoneStyle");

      if (style !== undefined && style !== "") {
        bone.addClass(style);
      }

      return bone;
    }
    /**
     * Updates the `regionData` based on the new ghost anchor location. Should be redefined in child classes.
     * @param p - The new ghost anchor location.
     */

  }, {
    key: "updateRegion",
    value: function updateRegion(p) {
      var x1 = p.x;
      var y1 = p.y;
      var x2;
      var y2;
      var flipX = false;
      var flipY = false;
      var activeAnchor = this.getActiveAnchor();

      switch (activeAnchor) {
        case "TL":
          {
            x2 = this.x + this.width;
            y2 = this.y + this.height;
            flipX = x2 < x1;
            flipY = y2 < y1;
            break;
          }

        case "TR":
          {
            x2 = this.x;
            y2 = this.y + this.height;
            flipX = x1 < x2;
            flipY = y2 < y1;
            break;
          }

        case "BL":
          {
            y2 = this.y;
            x2 = this.x + this.width;
            flipX = x2 < x1;
            flipY = y1 < y2;
            break;
          }

        case "BR":
          {
            x2 = this.x;
            y2 = this.y;
            flipX = x1 < x2;
            flipY = y1 < y2;
            break;
          }

        case "T":
          {
            x1 = this.x;
            x2 = this.x + this.width;
            y2 = this.y + this.height;
            flipY = y1 > y2;
            break;
          }

        case "R":
          {
            x2 = this.x;
            y1 = this.y;
            y2 = this.y + this.height;
            flipX = x2 > x1;
            break;
          }

        case "B":
          {
            x1 = this.x;
            x2 = this.x + this.width;
            y2 = this.y;
            flipY = y1 < y2;
            break;
          }

        case "L":
          {
            x2 = this.x + this.width;
            y1 = this.y;
            y2 = this.y + this.height;
            flipX = x1 > x2;
            break;
          }
      }

      var newAA = "";

      if (activeAnchor !== "" && activeAnchor.length === 2) {
        newAA += activeAnchor[0] === "T" ? flipY ? "B" : "T" : flipY ? "T" : "B";
        newAA += activeAnchor[1] === "L" ? flipX ? "R" : "L" : flipX ? "L" : "R";
      }

      if (activeAnchor !== "" && activeAnchor.length === 1) {
        if (flipX) {
          newAA = activeAnchor === "R" ? "L" : "R";
        } else if (flipY) {
          newAA = activeAnchor === "T" ? "B" : "T";
        } else {
          newAA = activeAnchor;
        }
      }

      if (activeAnchor !== newAA) {
        this.ghostAnchor.removeClass(activeAnchor);

        if (newAA.length === 2) {
          this.activeAnchorIndex = this.anchorPointStyles.indexOf(newAA) + 1;
        } else {
          this.activeAnchorIndex = -(this.anchorBoneStyles.indexOf(newAA) + 1);
        }

        activeAnchor = newAA;
        this.ghostAnchor.addClass(newAA);
      }

      var p1 = new Point2D_1.Point2D(Math.min(x1, x2), Math.min(y1, y2)).boundToRect(this.paperRect);
      var p2 = new Point2D_1.Point2D(Math.max(x1, x2), Math.max(y1, y2)).boundToRect(this.paperRect);
      var rd = this.regionData.copy();
      rd.setPoints([p1, new Point2D_1.Point2D(p2.x, p1.y), p2, new Point2D_1.Point2D(p1.x, p2.y)]);
      this.callbacks.onChange(this, rd, IRegionCallbacks_1.ChangeEventType.MOVING);
    }
    /**
     * Callback for the pointerenter event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerEnter",
    value: function onGhostPointerEnter(e) {
      this.ghostAnchor.addClass(this.getActiveAnchor());

      _get(_getPrototypeOf(AnchorsElement.prototype), "onGhostPointerEnter", this).call(this, e);
    }
    /**
     * Callback for the pointerleave event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerLeave",
    value: function onGhostPointerLeave(e) {
      this.ghostAnchor.removeClass(this.getActiveAnchor());

      _get(_getPrototypeOf(AnchorsElement.prototype), "onGhostPointerLeave", this).call(this, e);
    }
    /**
     * Helper function to subscribe anchor to activation event.
     * @param bone - The anchor bone for wire up.
     * @param index - The index of the anchor used to define which one is active.
     */

  }, {
    key: "subscribeAnchorBoneToEvents",
    value: function subscribeAnchorBoneToEvents(bone, index) {
      var _this4 = this;

      this.subscribeToEvents([{
        event: "pointerenter",
        base: bone.node,
        listener: function listener(e) {
          if (!_this4.isFrozen) {
            _this4.activeAnchorIndex = index;

            var anchorPoint = _this4.getActiveAnchorPoint(e); // Move ghost anchor to current anchor position


            window.requestAnimationFrame(function () {
              _this4.ghostAnchor.attr({
                cx: anchorPoint.x,
                cy: anchorPoint.y,
                display: "block"
              });
            });
          }
        },
        bypass: false
      }]);
    }
    /**
     * Returns `Point2D` with coordinates of active anchor
     */

  }, {
    key: "getActiveAnchorPoint",
    value: function getActiveAnchorPoint(e) {
      if (this.activeAnchorIndex > 0) {
        return this.regionData.points[this.activeAnchorIndex - 1];
      } else if (this.activeAnchorIndex < 0) {
        if (e !== undefined) {
          var offsetX = e.clientX - e.target.closest("svg").getBoundingClientRect().left;
          var offsetY = e.clientY - e.target.closest("svg").getBoundingClientRect().top;
          return new Point2D_1.Point2D(offsetX, offsetY);
        } else {
          var boneBox = this.anchorBones[-this.activeAnchorIndex - 1].getBBox();
          return new Point2D_1.Point2D(boneBox.cx, boneBox.cy);
        }
      } else {
        return null;
      }
    }
    /**
     * Internal helper function to get active anchor.
     */

  }, {
    key: "getActiveAnchor",
    value: function getActiveAnchor() {
      if (this.activeAnchorIndex > 0) {
        // anchor point is activeted
        return this.anchorPointStyles[this.activeAnchorIndex - 1];
      } else if (this.activeAnchorIndex < 0) {
        // anchor bone is activeted, indexes are negative starting -1
        return this.anchorBoneStyles[-this.activeAnchorIndex - 1];
      } else {
        return "";
      }
    }
  }]);

  return AnchorsElement;
}(AnchorsComponent_1.AnchorsComponent);

exports.AnchorsElement = AnchorsElement;